import SlAlert from '@shoelace-style/shoelace/dist/react/alert';  // keep this import even if not directly used


// Always escape HTML for text arguments!
const escapeHtml = (html)  => {
    const div = document.createElement('div');
    div.textContent = html;
    return div.innerHTML;
}

// create a toast notification as a modal
export const makeToast = (message, variant = 'primary', icon = 'info-circle', duration = 5000) => {

    if (document.querySelector('sl-alert')) {
        return;  // do nothing if there is already a toast
    }

    if (variant === 'warning') {
        icon = 'exclamation-square'
    } else if (variant === 'danger') {
        icon = 'x-octagon'
    }

    const alert = Object.assign(document.createElement('sl-alert'), {
        variant,
        closable: true,
        duration: duration,
        innerHTML: `
            <sl-icon name="${icon}" slot="icon"></sl-icon>
            ${escapeHtml(message)}
        `
    });

    document.body.append(alert);

    return alert.toast();
}
